import React, { useEffect } from 'react';
import { Layout as LayoutAntd } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import Sider from '../Sider/Sider';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Disclaimer from '../Disclaimer';
import './Layout.css';

const { Content } = LayoutAntd;

const Layout = ({ children, user, onLogout, investmentType, onSelectInvestmentType, availableTypes, isPreviewMode, isPublicPage }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Contact 페이지에서 로그아웃 시 로그인 페이지로 리다이렉트
  const handleLogout = () => {
    onLogout();
    if (isPublicPage) {
      navigate('/login');
    }
  };

  return (
    <LayoutAntd className="app-layout">
      <Sider 
        user={user}
        investmentType={investmentType}
        onSelectInvestmentType={onSelectInvestmentType}
        availableTypes={availableTypes}
        onLogout={handleLogout}
      />
      <LayoutAntd>
        <Header 
          user={user}
          onLogout={handleLogout}
          investmentType={investmentType}
          onSelectInvestmentType={onSelectInvestmentType}
          availableTypes={availableTypes}
          isPreviewMode={isPreviewMode}
        />
        <Content className="app-content">
          {children}
        </Content>
        <div className="layout-footer-section">
          <Disclaimer />
          <Footer />
        </div>
      </LayoutAntd>
    </LayoutAntd>
  );
};

export default Layout;
